<template>
    <div>
        <Head title="Stories"/>
        <h1 class="mb-8 text-3xl font-bold">Stories</h1>
        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" @update:model-value="update">
            </search-filter>
            <Link class="btn-indigo" href="/story/create">
                <span>Create</span>
                <span class="hidden md:inline"> Story</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Title</th>
                    <!--                    <th class="pb-4 pt-6 px-6">Girls</th>-->
                    <th class="pb-4 pt-6 px-6">Views</th>
                    <th class="pb-4 pt-6 px-6" colspan="2">CreatedAt</th>
                </tr>
                <tr v-for="(story,index) in stories.data || []" :key="index+1"
                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t pb-4 pt-6 px-6">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="`/story/${story.id}/edit`">
                            {{ story.title.slice(0, 30) }}
                        </Link>
                    </td>
                    <td class="border-t pb-4 pt-6 px-6">
                        {{ story.story_views_count }}
                    </td>
                    <td class="border-t pb-4 pt-6 px-6">
                        {{ moment(story.created_at).format('MMM DD, YYYY h:mm A') }}
                    </td>

                    <td class="w-px border-t">
                        <div class="flex">
                            <Link class="flex items-center px-4" :href="`/story/${story.id}/edit`" tabindex="-1">
                                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                            </Link>
                            <button class="flex items-center px-4" @click="deleteStory(story.id)" tabindex="-1">
                                <font-awesome-icon :icon="['fas', 'trash-alt']" />
                            </button>
                        </div>
                    </td>
                </tr>
                <tr v-if="stories.data.length === 0">
                    <td class="px-6 py-4 border-t text-center" colspan="4">No story found.</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="stories.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Components/Pagination'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import moment from 'moment';
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'
import mapValues from 'lodash/mapValues';
import throttle from 'lodash/throttle';
import pickBy from 'lodash/pickBy';

library.add(faTrashAlt);

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        FontAwesomeIcon,
        SearchInput,
        SearchFilter
    },
    layout: Layout,
    props: {
      filters: Object,
      stories: Array,
    },
    data() {
        return {
            form: {
                search: this.filters.search
            },
            moment: moment
        }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get('/story', pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    methods:{
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        async deleteStory(id) {
            const confirmed = confirm('Are you sure you want to delete this story?');
            if (!confirmed) {
                return;
            }

            await this.$inertia.delete(`/story/${id}`);
        },
    }


}
</script>
